// Turni e P.P (pausa pranzo, un'ora) del giorno: li cambia solo la responsabile (o lo sviluppo), come le regole.
// Documento «giorni/<AAAA-MM-GG>»: { turni: { op1: true… }, pause: { op1: '12:00' } }. L'agenda li usa per i controlli.
// Qui si cambiano anche i nomi delle operatrici (documento della struttura, valgono per tutti i giorni).
import { t } from '../i18n.js';
import { h, sostituisci, apriFoglio, chiudiFoglio, seguiInvio } from './dom.js';
import { giornoLungo } from './date.js';
import {
  OPERATRICI, ORARI_PAUSA, PAUSA, toMin, hm, inTurno, pausa, nomeOperatrice, conflittiDelGiorno,
} from '../logica/agenda.js';
import { campo, spunta, testiInvio } from './prenotazione.js';

const pulisciNome = (v) => String(v || '').replace(/\s+/g, ' ').trim().slice(0, 24);
const soloPieni = (nomi) => Object.fromEntries(OPERATRICI.filter((o) => pulisciNome(nomi?.[o])).map((o) => [o, pulisciNome(nomi[o])]));

/** Riga dell'agenda: chi è in turno e la sua P.P. */
export function testoTurno(giorno, op) {
  if (!inTurno(giorno, op)) return t('turni.fuori');
  const p = pausa(giorno, op);
  return p ? t('turni.conPausa', { da: hm(p.s), a: hm(p.e) }) : t('turni.in');
}

/** @param {object} vista dall'agenda: { scritture, data(), dati(), nomi() } */
export function apriTurni(vista) {
  const data = vista.data();
  const dati = vista.dati()?.data === data ? vista.dati() : null;
  const nomi = vista.nomi();
  const righe = OPERATRICI.map((o, i) => {
    const attuale = dati?.pause?.[o] || '';
    const ore = ORARI_PAUSA.includes(attuale) || !attuale ? ORARI_PAUSA : [...ORARI_PAUSA, attuale].sort((a, b) => toMin(a) - toMin(b));
    const nome = h('input', {
      id: `t-nome-${o}`, value: nomi[o] || '', placeholder: t('op.n', { n: i + 1 }), maxlength: 24, autocomplete: 'off',
    });
    const on = h('input', { type: 'checkbox', id: `t-on-${o}`, checked: inTurno(dati, o) });
    const pp = h('select', { id: `t-pp-${o}` },
      h('option', { value: '' }, t('turni.nessunaPausa')),
      ore.map((x) => h('option', { value: x, selected: x === attuale }, `${hm(toMin(x))}–${hm(toMin(x) + PAUSA)}`)));
    const box = h('fieldset', { classe: 'turno', dati: { op: o } },
      h('legend', {}, nomeOperatrice(o, nomi)),
      campo(t('turni.nome'), nome),
      spunta(t('turni.inTurno'), on),
      campo(t('turni.pausa'), pp));
    return { o, nome, on, pp, box };
  });
  const msg = h('ul', { classe: 'msgs', id: 't-msg', 'aria-live': 'polite' });
  const salva = h('button', { type: 'submit', classe: 'primario', id: 't-salva' }, t('turni.salva'));
  const form = h('form', { id: 't-form', novalidate: true },
    righe.map((r) => r.box),
    h('p', { classe: 'hint' }, t('turni.spiega')),
    h('p', { classe: 'hint' }, t('turni.spiegaNomi')),
    msg,
    h('div', { classe: 'azioni' }, h('button', { type: 'button', onclick: () => chiudiFoglio() }, t('modulo.annulla')), salva));

  const leggi = () => ({
    turni: Object.fromEntries(righe.map((r) => [r.o, r.on.checked])),
    pause: Object.fromEntries(righe.filter((r) => r.pp.value).map((r) => [r.o, r.pp.value])),
  });

  // Avvisi (non bloccano): prenotazioni già scritte che con i turni nuovi non vanno più bene.
  function controlla() {
    const nuovo = leggi();
    const nomiNuovi = { ...nomi, ...soloPieni(Object.fromEntries(righe.map((r) => [r.o, r.nome.value]))) };
    const lista = dati ? conflittiDelGiorno({ ...dati, ...nuovo }, { nomi: nomiNuovi }) : [];
    sostituisci(msg, lista.flatMap(({ prenotazione: b, problemi }) => problemi.map((p) => h('li', { classe: 'w' },
      t('turni.conflitto', { ora: hm(toMin(b.inizio)), nome: b.nome || t('ctrl.unOspite'), problema: p })))));
  }

  form.addEventListener('input', controlla);
  form.addEventListener('change', controlla);
  form.addEventListener('submit', (e) => {
    e.preventDefault();
    salva.disabled = true;
    const nomiNuovi = soloPieni(Object.fromEntries(righe.map((r) => [r.o, r.nome.value])));
    const cambiati = JSON.stringify(nomiNuovi) !== JSON.stringify(soloPieni(nomi)) ? nomiNuovi : null;
    const r = vista.scritture.salvaGiorno(data, leggi(), cambiati);
    chiudiFoglio();
    seguiInvio(r.conferma, t('salvato.turni'), testiInvio());
  });

  apriFoglio({ sopra: giornoLungo(data), titolo: t('turni.titolo'), chiudi: t('foglio.chiudi') }, form);
  controlla();
}
